import { Users, MapPin, Clock, DollarSign } from 'lucide-react';

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription
} from '@/components/ui/card';

import OfferingCategoryBadge from '@/app/offeringCategory/OfferingCategoryBadge';

const OfferingCard = ({ offering }) => {
  return (
    <Card className="max-w-lg">
      <CardHeader className="p-4">
        <CardTitle className="flex items-center justify-between text-lg font-bold">
          <div className="flex items-center gap-2">{offering.name}</div>
          {offering.isGroup && <Users />}
        </CardTitle>
        <CardDescription>{offering.description}</CardDescription>
      </CardHeader>
      <CardContent className="px-4 space-y-1">
        <div className="grid grid-cols-2 text-sm mb-4">
          <div className="space-y-1">
            <div className="flex items-center space-x-2">
              <Clock className="w-4 h-4 text-muted-foreground" />
              <span>{offering.length} minutes</span>
            </div>
            <div className="flex items-center space-x-2">
              <DollarSign className="w-4 h-4 text-muted-foreground" />
              <span>
                {(offering.pricePerClient / 100).toFixed(2)} {offering.currency}
                /ea
              </span>
            </div>
          </div>
          <div className="space-y-1">
            {offering.location && (
              <div className="flex items-center space-x-2">
                <MapPin className="w-4 h-4 text-muted-foreground" />
                <span>{offering.location.name}</span>
              </div>
            )}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4 mb-8">
          <div className="mb-4">
            <h3 className="text-md font-md text-muted-foreground mb-1">
              Booking Lead Time
            </h3>
            <div className="text-sm">{offering.bookingLeadTime} hrs</div>
          </div>
          <div className="mb-4">
            <h3 className="text-md font-md text-muted-foreground mb-1">
              Category
            </h3>
            <OfferingCategoryBadge offeringCategoryId={offering.categoryId} />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4 mb-8">
          <div className="mb-4">
            <h3 className="text-md font-md text-muted-foreground mb-1">
              Description
            </h3>
            <div className="text-sm">{offering.description || '--'}</div>
          </div>
          <div className="mb-4">
            <h3 className="text-md font-md text-muted-foreground mb-1">
              Meeting Spot
            </h3>
            <div className="text-sm">
              {offering.isMeetingSpot ? 'Yes' : 'No'}
            </div>
            {offering.locationName && (
              <div className="text-sm">{offering.locationName}</div>
            )}
            {offering.locationDetails && (
              <div className="text-sm">{offering.locationDetails}</div>
            )}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4 mb-8">
          <div className="mb-4">
            <h3 className="text-md font-md text-muted-foreground mb-1">
              Requirements
            </h3>
            <div className="text-sm">{offering.requirements || '--'}</div>
          </div>
          <div className="mb-4">
            <h3 className="text-md font-md text-muted-foreground mb-1">
              Included
            </h3>
            <div className="text-sm">{offering.includedItems || '--'}</div>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4 mb-8">
          <div className="mb-4">
            <h3 className="text-md font-md text-muted-foreground mb-1">
              Not Included
            </h3>
            <div className="text-sm">{offering.notIncludedItems || '--'}</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default OfferingCard;
